import { __assign, __read, __spreadArray } from "tslib";
import React, { useState } from 'react';
import { Typography, MenuItem, } from '@material-ui/core';
import { FlexColumn } from '../Flex/FlexColumn';
import { Select } from '../Select/Select';
/** @deprecated Use Select instead, if you need the label, use <FormField label=".."><Select /><FormField /> */
export var Dropdown = React.forwardRef(function (props, ref) {
    var value = props.value, _a = props.inputProps, inputProps = _a === void 0 ? {} : _a, _b = props.selectProps, selectProps = _b === void 0 ? {} : _b, title = props.title, onChange = props.onChange, choices = props.choices, renderer = props.renderer, placeholder = props.placeholder;
    var _c = __read(useState(value && choices.includes(value) ? value : ''), 2), selection = _c[0], setSelection = _c[1];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var handleChange = function (event) {
        var change = event.target.value;
        setSelection(change);
        onChange && onChange(change);
    };
    return (React.createElement(FlexColumn, null,
        title && (React.createElement(Typography, { variant: "subtitle2", component: "label", htmlFor: inputProps.id }, title)),
        React.createElement(Select, __assign({}, selectProps, { ref: ref, native: true, value: selection, onChange: handleChange, inputProps: __assign(__assign({}, inputProps), { 'data-e2e-component': 'select-dropdown' }) }), choices.length && __spreadArray([
            placeholder && (React.createElement(MenuItem, { key: "placeholder", component: "option", value: "", disabled: true }, placeholder))
        ], __read(choices.map(function (choice, index) {
            return renderer ? (renderer(choice, index)) : (React.createElement("option", { key: index, value: choice }, choice));
        }))))));
});
//# sourceMappingURL=Dropdown.js.map